import React, { useContext } from 'react';
import { ComponentContext } from '../../contexts';
export const Table = (genericTableProps) => {
    const { Table: EditorOrViewerTable } = useContext(ComponentContext);
    return React.createElement(EditorOrViewerTable, { ...genericTableProps });
};
//# sourceMappingURL=table.js.map